<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>
<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>

      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin ">
          <!-- //****************** -->

          <button class="approved" [disabled]="RAC_APROVE!=1" *ngIf="isApproved && actionmode == 'Edit' && rejected!=2">

            <span class="bold">Approved</span>
          </button>
          <input type="button" [disabled]="RAC_APROVE!=1" class="btn btn-success commonbutt"
            style="width: 80px;font-weight: 700" value="Active" id="btnname" (click)="changeName()"
            *ngIf="isApproved && actionmode == 'Edit' && rejected!=2" />
          <!-- //****************** -->

          <button *ngIf="!viewpage" [disabled]="
            data_present ||
              onlyspaces ||
              showList == true ||
              viewpage == true ||
              invalidCityName ||
              onlyspclchar ||
              onlynum ||
              exceedLength ||
              notAlphabet ||
              minlength ||
              cnameExceed ||
              mincityname ||
              onlynumc ||
              nameExist ||
              nameExist1 ||
              loader 
            
            " class="btn btn-success commonbutt" type="button" (click)="submitData1()">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>

          <button [disabled]="
          onlyspaces ||
          nameExist ||
          nameExist1 ||          
          invalidCityName ||
          onlyspclchar ||
          onlynum ||
          exceedLength ||
          notAlphabet ||
          minlength ||
          cnameExceed ||
          mincityname ||
          onlynumc  ||
          data_present ||
          loader
          
        " class="btn btn-success commonbutt" type="button" *ngIf="!isApproved && updateApprove && RAC_APROVE == '1'"
            data-toggle="modal" data-target="#myModal">
            <em class="fa fa-thumbs-up "></em>&nbsp;&nbsp;
            <span class="bold">Approve</span>
          </button>
          <button [disabled]="
          onlyspaces ||
          nameExist ||
         nameExist1 || 
          invalidCityName ||
          onlyspclchar ||
          onlynum ||
          exceedLength ||
          notAlphabet ||
          minlength ||
          cnameExceed ||
          mincityname ||
          onlynumc  ||
          data_present ||
          loader
        " class="btn btn-warning commonbutt" type="button" *ngIf="!isApproved && updateApprove && RAC_APROVE == '1'"
            data-toggle="modal" data-target="#myModal2">
            <em class="fa fa-thumbs-down"></em> <span class="bold">Reject</span>
          </button>

          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>


                      <div [hidden]="!viewpage" class="tdive">
                        <table aria-describedby="cityMasterDetails" class="viewtable">
                          <div *ngFor="let q of viewPageDetails">
                            <tr>
                              <th scope="col">
                                <span class="vlbl">City Code</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.CITY_CODE }}</span>
                              </td>
                            </tr>

                            <tr>
                              <th scope="col">
                                <span class="vlbl">City Name</span>
                              </th>
                              <td>

                                <span class="vVal">{{ q.CITY_NAME }}</span>

                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Country Code</span>
                              </th>
                              <td>
                                <span class="vVal"> {{ q.COUNTRY_CODE }} </span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">

                                <span class="vlbl">Country Name</span>
                              </th>
                              <td>
                                <span class="vVal"> {{ ctryname }} </span>
                              </td>
                            </tr>


                          </div>


                        </table>
                      </div>
                      <div [hidden]="viewpage">

                        <div *ngIf="loader">
                          <div style="margin-left: 323px;text-align: center;position: absolute;z-index: 1;">
                            <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                          </div>
                        </div>

                        <div class="col-lg-3">
                          <label>City Code</label>
                          <input maxlength="3" style="text-transform: uppercase;" [(ngModel)]="screen_details.CITY_CODE"
                            type="text" #code="ngModel" [disabled]="actionmode =='Edit'"
                            (input)="checkLength($event.target.value)" (change)="gotochangestatus()"
                            (blur)="checkIt($event.target.value, 1)" class="form-control m-input"
                            placeholder="Enter City Code" />

                          <span *ngIf="nameExist" style="color: red"> City code already exist </span>

                          <span *ngIf="exceedLength" style="color: red">{{
                            ccode1
                            }}</span>

                          <span *ngIf="notAlphabet" style="color: red">{{
                            ccode2
                            }}</span>

                          <span *ngIf="minlength && !notAlphabet" style="color: red">{{
                            ccode3
                            }}</span>

                        </div>
                        <div class="col-lg-3">
                          <label class="">City Name</label>
                          <input maxlength="125" (change)="gotochangestatus()" [(ngModel)]="screen_details.CITY_NAME"
                            id="CITY_NAME" type="text" [pattern]="namePattern" #name="ngModel"
                            (input)="checkCityName($event.target.value)" [disabled]="showList == true"
                            (blur)="onBlurCity($event.target.value);checkNames1();" class="form-control m-input"
                            placeholder="Enter City Name" />
                          <span *ngIf="nameExist1" style="color: red"> City name already exist </span>
                          <span style="color: red" *ngIf="cnameExceed">Max limit is 125 characters</span>
                          <span style="color: red" *ngIf="mincityname && !onlynum">Min limit is 3 char</span>
                          <span style="color: red" *ngIf="onlynum">Accepts alphabets & special characters only</span>
                          <span style="color: red" *ngIf="invalidCityName">Invalid city name
                          </span>
                          <span style="color: red" *ngIf="onlyspaces">City name should not be empty
                          </span>
                        </div>

                        <div class="col-lg-3">
                          <label class="">Country Name</label>


                          <select name="COUNTRY_CODE" class="form-control" [(ngModel)]="screen_details.COUNTRY_CODE"
                            [disabled]="showList == true" (change)="hidemsg()">
                            <option disabled value="0">Select Country Name</option>

                            <option value="{{combo.COUNTRY_CODE}}" *ngFor="let combo of combo_details1">{{
                              combo.COUNTRY_NAME }}</option>
                          </select>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="history" role="dialog">
  <div class="modal-dialogh">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;"></div>

      <div class="modal-body">
        <div class="poph">
          <table aria-describedby="cityMasterDataAction" class="table table-striped">
            <tr>
              <th scope="col" style="width: 10%">Action</th>

              <th scope="col" style="width: 10%">New Record</th>
              <th scope="col" style="width: 10%">Changed Record</th>
              <th scope="col" style="width: 10%">Table Name</th>
              <th scope="col" style="width: 10%">Modified Date</th>
              <th scope="col" style="width: 10%">Modified Time</th>
              <th scope="col" style="width: 10%">Modified by</th>
            </tr>
            <tr *ngFor="let item of Audit_History">
              <td>{{ item.ACTION }}</td>

              <td>{{ item.NEW_RECORD }}</td>
              <td>{{ item.CHANGED_RECORD }}</td>
              <td>{{ item.TABLE_NAME }}</td>
              <td>{{ item.MODIFIED_TIME | date }}</td>
              <td>{{ item.MODIFIED_TIME | date: "HH:mm:ss" }}</td>
              <td>{{ item.MODIFIED_BY }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>

<!-- city master component modal starts here  -->
<div class="modal fade" id="myModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;">
        <button type="button" 
        (click)="clearRemark()" class="close" 
         data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-thumbs-up" 
          style="margin-right: 10px"></span>Do you want to approve ?</h4>
      </div>

      <!-- city master modal body  -->
      <div class="modal-body">
        <div class="col-lg-13">
          <label> Remarks</label>
          <textarea 
          [(ngModel)]="aprove_details.APPROVAL_REMARKS" 
          (input)="getremark($event.target.value);"
          (blur)="checkRemarkLength($event.target.value)" 
          rows="8" cols="20" type="text" class="form-control m-input"
          placeholder="Enter  Remarks">
          </textarea>
          <span 
            *ngIf="minRemark" 
            class="m-form__help" style="color: red">Please enter Remarks with minimum length 3</span>
        </div>
      </div>
      <div class="modal-footer">
        <button 
          [disabled]="!aprvbtn" 
          class="btn btn-success " 
          type="button" (click)="aproveReject(1)"
          data-dismiss="modal">
          <span class="bold">Yes</span>
        </button>

        <button 
            class="btn btn-warning " 
            (click)="clearRemark()" type="button" 
            data-dismiss="modal">
          <span class="bold">No</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ########## city modal2 ends here -->

<!-- ########## modal 2 starts here-->
<div class="modal fade" id="myModal2" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;">
        <button type="button" class="close" (click)="clearRemark()" data-dismiss="modal">&times;</button>
        <h4 class="modal-title"><span class="glyphicon glyphicon-thumbs-down" style="margin-right: 10px"></span>Do you want to reject ?</h4>
      </div>
      <div class="modal-body">
        <div class="col-lg-13">
          <label>Remarks</label>
          <textarea 
          [(ngModel)]="aprove_details.APPROVAL_REMARKS" 
          rows="8" (input)="getremark($event.target.value);"
            (blur)="checkRemarkLength($event.target.value)" 
            cols="20" type="text" class="form-control m-input"
            placeholder="Enter  Remarks">
          </textarea>
          <span 
          *ngIf="minRemark" class="m-form__help" style="color: red">Please enter Remarks with minimum length
            3</span>
        </div>
      </div>
      <div class="modal-footer">
        <button 
        [disabled]="!aprvbtn" 
        class="btn btn-success" type="button" 
        (click)="aproveReject(2)"
          data-dismiss="modal">
          <span class="bold">Yes</span>
        </button>
        <button class="btn btn-warning " 
        (click)="clearRemark()" type="button" 
        data-dismiss="modal">
          <span class="bold">No</span>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ########## modal 2 ends here-->

<div *ngIf="actionmode != 'Add' && 
actionmode != 'Edit'" class="searchdiv">
  <div class="headerdiv">
    <h1>City Search</h1>
    <div class="bothbuttdiv">

      <button class="btn btn-primary commonbutt" *ngIf="RAC_ADD == '1'" type="button" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New
      </button>

    </div>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div>
            <div class="m-portlet">
              <div>
                <div>

                  <div class="wr15">



                    <div class="instruct">
                      <div class="int1" style="margin-left: 17px">
                        <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                        <br />


                        <span class="txt">
                          1. Select at least one value out of City Code, City Name or Country Name

                        </span>
                        <br />
                        <span class="txt">
                          2. You can also use a combination of the given fields to search </span>
                        <br />
                        <span></span>
                      </div>
                    </div>

                    <div class="col-lg-3">
                      <label>City Code</label>

                      <input maxlength="3" style="text-transform: uppercase;" [(ngModel)]="search_details.CITY_CODE"
                        type="text" #code="ngModel" (input)="checkLength1($event.target.value)"
                        (blur)="checkIt1($event.target.value, 1)" class="form-control m-input"
                        placeholder="Enter City Code" />

                      <span *ngIf="exceedLength1" style="color: red">{{
                        ccode1
                        }}</span>

                      <span *ngIf="notAlphabet1" style="color: red">{{
                        ccode2
                        }}</span>

                    </div>
                    <div class="col-lg-3">
                      <label class="">City Name</label>

                      <ng-select [(ngModel)]="search_details.CITY_NAME" [allowClear]="true" [options]="formstatusdata1"
                        #search_bank_name placeholder="Select City Name"
                        (input)="autoCompleteSearch1($event.target.value)" notFoundMsg={{auto_msg}}>
                      </ng-select>

                    </div>
                    <div class="col-lg-3">
                      <label class="">Country Name</label>

                      <ng-select [(ngModel)]="search_details.COUNTRY_NAME" [allowClear]="true"
                        [options]="formstatusdata" (input)="autoCompleteSearch($event.target.value)"
                        placeholder="Select Country Name" notFoundMsg={{auto_msg}}>
                      </ng-select>
                    </div>

                    <div class="col-lg-3">

                      <button style="
                        width: 83px;
                        margin-top: 25px;" class="btn btn-primary commonbutt"
                        [disabled]="exceedLength1 || notAlphabet1" (click)="searchData()" type="button">
                        <em class="fa fa-search "></em>&nbsp;Search
                      </button>
                    </div>


                    <div class="clr"></div>
                  </div>
                </div>
              </div>


              <div class="clr"></div>


              <div *ngIf="searchresult" style="padding: 2% 2% 2% 2%" [hidden]="searchlist">
                <table class="table table-striped" *ngIf="!loader" [mfData]="serachtabledata"
                  aria-describedby="cityData" [mfRowsOnPage]="5">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 20%" *ngIf="RAC_VIEW == '1' || RAC_EDIT == '1'">
                        Actions
                      </th>
                      <th scope="col" style="width: 20%">
                        <mfDefaultSorter by="CITY_CODE">City Code</mfDefaultSorter>
                      </th>
                      <th scope="col" style="width: 20%">
                        <mfDefaultSorter by="CITY_NAME">City Name</mfDefaultSorter>
                      </th>
                      <th scope="col" style="width: 30%">
                        <mfDefaultSorter by="COUNTRY_NAME">Country Name
                        </mfDefaultSorter>
                      </th>
                      <th scope="col" style="width: 20%">
                        <mfDefaultSorter by="STATUS">Status</mfDefaultSorter>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of (serachtabledata | paginate: { itemsPerPage: 10, currentPage: p })">
                      <td 
                      *ngIf="RAC_VIEW == '1' || 
                      RAC_EDIT == '1'">
                        <button class="btn btn-default btn-circle" 
                        *ngIf="RAC_VIEW == '1'" type="button"
                        (click)="showFormData(item.CITY_ID, 1, 1, 1)">
                          <em class="fa fa-eye"></em>
                        </button>
                        <span 
                        *ngIf="item.STATUS != '2' && 
                        item.PRE_APPROVE != '1'">
                          <button class="btn btn-default btn-circle" 
                          *ngIf="RAC_EDIT == '1'" type="button" 
                          (click)="showFormData(item.CITY_ID,2,item.STATUS,item.APPROVAL_STATUS)">
                            <em class="fa fa-pencil"></em>
                          </button>
                        </span>
                      </td>
                      <td>{{ item.CITY_CODE | uppercase }}</td>
                      <td>{{ item.CITY_NAME }}</td>
                      <td>{{ item.COUNTRY_NAME }}</td>
                      <td>


                        <div *ngIf="item.APPROVAL_STATUS == 0 &&
                            item.STATUS == 0 && item.PRE_APPROVE != 1">
                          <span class="icls1">
                            <button class="btn commonbutt zol1">
                              Inactive
                            </button>

                            <span class="tooltiptext">Not Approved</span>
                          </span>
                        </div>

                        <div *ngIf="item.APPROVAL_STATUS == 1 &&
                         item.PRE_APPROVE != 1">
                          <span class="icls1">
                            <button class="btn  commonbutt zol" 
                            *ngIf="item.STATUS == 1">
                              Active
                            </button>

                            <button class="btn  commonbutt zol1" 
                            *ngIf="item.STATUS == 0">
                              Inactive
                            </button>

                            <span class="tooltiptext"> Approved </span>

                          </span>
                        </div>
                        <div *ngIf="item.APPROVAL_STATUS == 0 && 
                              item.PRE_APPROVE == 1">
                          <span class="icls1">
                            <button class="btn  commonbutt zol">
                              Active
                            </button>
                            <span class="tooltiptext"> Approved </span>
                          </span>
                        </div>


                        <div 
                        *ngIf="item.APPROVAL_STATUS == 2 && 
                              item.STATUS == 2">
                          <span class="icls5">
                            <button class="btn  commonbutt zol1">
                              Inactive
                            </button>
                            <span class="tooltiptext">Rejected</span>
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="5"><pagination-controls (pageChange)="p = $event"></pagination-controls></td>
                    </tr>
                  </tfoot>
                </table>
                <!-- ends here  -->
              </div>

              <div 
              *ngIf="loader">
                <div 
                style="margin: 0 auto; text-align: center;">
                  <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">
                </div>
              </div>
              <!-- loader ends here  -->
            </div>
          </div>
        </div>
        <!-- form action mode ends here  -->
      </div>
    </div>
  </div>
</div>
<!-- action modal ends here  -->